module.exports = __webpack_public_path__ + "0c047d79281477e7dc8f8f280feb243f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/detsky-tabor-1-4.jpg
// module id = 1214
// module chunks = 0